import { useEffect, useRef } from 'react';
import { injectScriptInHead } from './utils';
import { useLocalizationContext } from '@im/react-localization';
import { useReusableCookieDisclaimer } from '../../hooks/use-cookie-disclaimer';
import Cookies from 'js-cookie';
import { useIsOneTrustEnabled } from './useOneTrust';

type UseCookieDisclaimerTO = {
  resellerProspect: boolean;
};

export function useCookieDisclaimer({
  resellerProspect,
}: UseCookieDisclaimerTO) {
  const { locale } = useLocalizationContext();
  const oneTrustId = useIsOneTrustEnabled();
  const consentRequired =
    !resellerProspect &&
    !oneTrustId &&
    Cookies?.get('cookieconsent_dismissed') !== 'yes';
  const { data: disclaimerContent } = useReusableCookieDisclaimer(
    locale,
    consentRequired
  );
  const isScriptInjected = useRef(false);
  const scriptRef = useRef<HTMLScriptElement | undefined>();
  const win = window as any;

  useEffect(() => {
    if (
      disclaimerContent &&
      (disclaimerContent.reusableContents?.length ?? 0) > 0
    ) {
      if (!isScriptInjected.current) {
        injectScriptInHead(
          '/cep/app/static/scripts/CookieDisclaimer/cookie-bar.js'
        );
      }
      isScriptInjected.current = true;
      if (scriptRef.current) {
        try {
          document.head.removeChild(scriptRef.current);
          // eslint-disable-next-line no-empty
        } catch (e) {}
      }
      scriptRef.current = injectDisclaimerElement(
        disclaimerContent.reusableContents[0].content
      );
    }
  }, [disclaimerContent]);

  useEffect(() => {
    if (
      consentRequired &&
      win &&
      win.cookieconsent_options &&
      win.update_cookieconsent_options
    ) {
      win.update_cookieconsent_options(win.cookieconsent_options);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scriptRef.current]);
}

export function injectDisclaimerElement(html: string) {
  try {
    const content = html.replaceAll('[', "'").replaceAll(']', "'");
    const customEL = document.createElement('script');
    customEL.innerHTML = content;
    document.head.appendChild(customEL);
    return customEL;
  } catch (e) {
    return undefined;
  }
}
